import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

const componentName = 'wok-panel';

export default <FunctionalComponentOptions>{
    name: componentName,

    functional: true,

    props: {
        icon: {
            type: String,
            default: undefined
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'nav', { class: 'wok--ui-panel' }, [
                h('ul', { class: 'wok--ui-panel__list' }, [
                    ctx.slots().default
                ])
            ]
        )
    }
}